import React from 'react';
import Icon from 'relements/build/esm/ui/icon';

import ButtonV2 from '@src/components/ButtonV2';

import styles from './ListItem.scss';

const ListItemHeader = (props) => {
  const { icon, title, subText, buttonText, buttonClick } = props;

  return (
    <div className={styles.ListItemHeader}>
      <div className={styles.ListItemHeaderLHS}>
        <Icon src={icon} className={styles.ListItemHeaderLHSIcon} />
        <div className={styles.ListItemHeaderLHSDetails}>
          <div className={styles.ListItemHeaderLHSDetailsTitle}>{title}</div>
          <div className={styles.ListItemHeaderLHSDetailsSubText}>
            {subText}
          </div>
        </div>
      </div>
      <div className={styles.ListItemHeaderRHS}>
        <ButtonV2 onClick={buttonClick}>{buttonText}</ButtonV2>
      </div>
    </div>
  );
};

export default ListItemHeader;
